import { AlefFont } from '@/styles/fonts';
import NavigationBar from './NavigationBar';
import Link from 'next/link';
import { styled } from 'styled-components';
import { colors } from '@/styles/colors';
import { useTranslation } from 'next-i18next';
import { LocaleNS } from '@/lib/locale-ns';

const TutorialNavigationBar = () => {
    const { t } = useTranslation(LocaleNS.NAV_BARS);

    return (
        <NavigationBar>
            <StyledLink href="/contact" className={AlefFont.className}>
                {t('contact')}
            </StyledLink>
            <StyledLink href="/about" className={AlefFont.className}>
                {t('about')}
            </StyledLink>
            <StyledLink href="/landing" className={AlefFont.className}>
                {t('design-invitation')}
            </StyledLink>
        </NavigationBar>
    );
};

const StyledLink = styled(Link)`
    font-size: 16px;
    letter-spacing: 1.5px;
    color: ${colors.offWhite};
    height: 100%;

    &:hover {
        color: ${colors.textSecondary};
    }
`;

export default TutorialNavigationBar;
